/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDomain = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-1 14-2.44.001c.547 1.818 1.441 3.17 2.44 3.723zm4.44.001L13 16v3.724c1-.555 1.893-1.906 2.44-3.723zm-8.956 0H5.071a8.041 8.041 0 0 0 2.369 2.573 12.277 12.277 0 0 1-.956-2.573zm12.445 0h-1.413a12.26 12.26 0 0 1-.956 2.573A8.038 8.038 0 0 0 18.929 16zM6.116 10H4.252A8.014 8.014 0 0 0 4 12c0 .69.088 1.361.252 2l1.864.001a17.102 17.102 0 0 1 0-4.001zM11 10H8.132A14.962 14.962 0 0 0 8 12c0 .693.046 1.363.133 2H11zm8.748 0h-1.864a17.102 17.102 0 0 1 0 4.001h1.864a8.05 8.05 0 0 0 0-4.001zm-3.88 0H13v4h2.867a14.87 14.87 0 0 0 .13-1.702L16 12c0-.693-.046-1.362-.132-2zM7.44 5.427l-.127.09A8.04 8.04 0 0 0 5.07 8h1.414c.24-.94.562-1.808.956-2.574zM11 4.276C10.001 4.83 9.107 6.182 8.56 8H11zm5.56 1.15.08.161c.358.726.653 1.538.876 2.413h1.414a8.041 8.041 0 0 0-2.37-2.574zM13 4.276V8h2.44C14.893 6.182 14 4.83 13 4.276z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDomain as Domain };
